// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ProfileAdminTools":"iz_a bhy_vu bhy_ql bhy_va bhy_gy bhy_kg bhy_sv","ProfileAdminTools__item":"iz_b"};